import React from "react";
import {withNamespaces} from "react-i18next";
import {Link} from "react-router-dom";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Pagination} from "swiper";
import "swiper/swiper.less";
import {
    prefersReducedMotion,
} from "../../../../../presentation/public-site/motion-preference";

function ArrowIcon() {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.5415 8.5H13.4582M13.4582 8.5L9.56234 4.60417M13.4582 8.5L9.56234 12.3958"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function HeroNewsStrip({items = [], t}) {
    if (!items.length) {
        return null;
    }

    const hasMultipleItems = items.length > 1;
    const autoplayEnabled = (
        hasMultipleItems &&
        !prefersReducedMotion()
    );

    return (
        <div className="landing-hero-news" id="news">
            <div className="landing-hero-news__section">
                <span className="landing-hero-news__eyebrow">
                    <span/>
                    {t("main.landing.news.eyebrow")}
                </span>

                <strong>
                    {t("main.header.landingNavigation.news")}
                </strong>
            </div>

            <Swiper
                className="landing-hero-news__slider"
                slidesPerView={1}
                speed={650}
                loop={hasMultipleItems}
                autoplay={autoplayEnabled ? {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                } : false}
                pagination={hasMultipleItems ? {
                    clickable: true,
                    el: ".landing-hero-news__pagination",
                } : false}
                modules={[Autoplay, Pagination]}
            >
                {items.map((item) => {
                    const NewsLink = item.isExternal
                        ? "a"
                        : Link;

                    const linkProps = item.isExternal
                        ? {
                            href: item.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                        }
                        : {
                            to: item.url,
                        };

                    return (
                        <SwiperSlide key={item.id}>
                            <NewsLink
                                className="landing-hero-news__item"
                                {...linkProps}
                            >
                                <span className="landing-hero-news__badge">
                                    {t(item.badgeKey)}
                                </span>

                                <span className="landing-hero-news__content">
                                    <span className="landing-hero-news__meta">
                                        {t(item.metaKey)}
                                    </span>

                                    <strong className="landing-hero-news__title">
                                        {t(item.titleKey)}
                                    </strong>

                                    <span className="landing-hero-news__description">
                                        {t(item.descriptionKey)}
                                    </span>
                                </span>

                                <span className="landing-hero-news__side">
                                    <strong className="landing-hero-news__year">
                                        {item.year}
                                    </strong>

                                    <span className="landing-hero-news__action">
                                        {t(item.actionKey)}
                                        <ArrowIcon/>
                                    </span>
                                </span>
                            </NewsLink>
                        </SwiperSlide>
                    );
                })}
            </Swiper>

            {hasMultipleItems && (
                <div
                    className="landing-hero-news__pagination"
                    aria-label={t("main.landing.news.paginationAriaLabel")}
                />
            )}
        </div>
    );
}

export default withNamespaces("translation")(HeroNewsStrip);
